/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Swedish
export default {
  'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': 'Rensa urval',
  'paginated-picker.async-select.menu-list.error-message.error-message': 'Det gick inte att hämta data',
  'paginated-picker.async-select.menu-list.error-message.retry-message': 'Klicka för att försöka igen',
  'paginated-picker.async-select.menu-list.loading-message.loading-message': 'Läser in ...',
  'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': 'Visa mer',
  'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount} av {totalCount}',
  'paginated-picker.async-select.select.no-options-message.no-options-message': 'Inga träffar hittades',
  'paginated-picker.async-select.select.option.error-message': 'Det gick inte att hämta data',
  'paginated-picker.async-select.select.option.retry-message': 'Klicka för att försöka igen',
  'paginated-picker.async-select.select.search-placeholder': 'Sök',
  'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': 'Visa fullständig lista'
};